export default __webpack_public_path__ + "static/media/wrong-cancel-stop-cross.64583963.svg";